"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewTodoContainer = exports.OverviewStatusContainer = void 0;
var React = require("react");
var container_1 = require("./container");
var charts_1 = require("./charts");
var App_1 = require("../../App");
var OverviewStatusContainer = (function (_super) {
    __extends(OverviewStatusContainer, _super);
    function OverviewStatusContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewStatusContainer.prototype.render = function () {
        return (React.createElement(container_1.Container, { borderless: true },
            React.createElement(charts_1.PieChart, { data: this.props.values, onElementClick: this.onClick.bind(this), colors: ['#C6EEFF', '#53CCFF', '#00AEEF', '#006896', '#797766'] })));
    };
    OverviewStatusContainer.prototype.onClick = function (obj) {
        var project_group = $("#filter_project option:selected").text();
        App_1.store.editableListDialog.openDialog(project_group + " | " + (this.props.title || "") + " | " + obj.data.label, obj.data);
    };
    return OverviewStatusContainer;
}(React.Component));
exports.OverviewStatusContainer = OverviewStatusContainer;
var OverviewTodoContainer = (function (_super) {
    __extends(OverviewTodoContainer, _super);
    function OverviewTodoContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewTodoContainer.prototype.render = function () {
        var horizontalBarPlotData = [{
                key: "",
                values: this.props.values,
            }];
        return (React.createElement(container_1.Container, { borderless: true, containerSubTitle: this.props.subtitle },
            React.createElement(charts_1.MultiBarHorizontalChart, { data: horizontalBarPlotData, onElementClick: this.onClick.bind(this), heightModifier: 20, showLegend: false, showXAxis: true, showYAxis: false, showTooltip: false, colors: ['#00AEEF'] })));
    };
    OverviewTodoContainer.prototype.onClick = function (obj) {
        var project_group = $("#filter_project option:selected").text();
        App_1.store.editableListDialog.openDialog(project_group + " | " + (this.props.title || "") + " | " + obj.data.label, obj.data);
    };
    return OverviewTodoContainer;
}(React.Component));
exports.OverviewTodoContainer = OverviewTodoContainer;
